import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { CreateTemplateTabViewState } from "../Components/Scheduling/CreateTemplateTab";
import { OpenScheduleTabViewState } from "../Components/Scheduling/OpenScheduleTab";
import { SchedulerHelper } from "../Helpers/SchedulerHelper";
import { ICreateTemplateTabModel } from "../Models/UI/Scheduling/ICreateTemplateTabModel";
import { IOpenScheduleTabModel } from "../Models/UI/Scheduling/IOpenScheduleTabModel";
import { ISchedulingTabModel } from "../Models/UI/Scheduling/ISchedulingTabModel";
import { ITemplateTabModel } from "../Models/UI/Scheduling/ITemplateTabModel";
import { SchedulingAction } from "./Actions/SchedulingActions";
import { CreateTemplateTabHandler } from "./Handlers/Local/Scheduling/CreateTemplateTabHandler";
import { MainTemplateTabHandler } from "./Handlers/Local/Scheduling/MainTemplateTabHandler";
import { OpenScheduleTabHandler } from "./Handlers/Local/Scheduling/OpenScheduleTabHandler";
import { SchedulingTabHandler } from "./Handlers/Local/Scheduling/SchedulingTabHandler";
import { SchedulingResponseHandler } from "./Handlers/Server/SchedulingResponseHandler";

let defaultInstance: SchedulingStore;

class SchedulingStore extends BaseStore {
    private mapper: RequestMapper;
    private serverMapper: ServerResponseMapper;

    private schedulingResponseHandler: SchedulingResponseHandler;

    private schedulingTabHandler: SchedulingTabHandler;
    private openScheduleTabHandler: OpenScheduleTabHandler;
    private mainTemplateTabHandler: MainTemplateTabHandler;
    private createTemplateTabHandler: CreateTemplateTabHandler;

    public SchedulingTabModel: ISchedulingTabModel;
    public OpenScheduleTabModel: IOpenScheduleTabModel;
    public TemplateTabModel: ITemplateTabModel;
    public CreateTemplateTabModel: ICreateTemplateTabModel;

    public schedulingAction: SchedulingAction;

    public currentState: OpenScheduleTabViewState;
    public currentTemplateState: CreateTemplateTabViewState;

    constructor() {
        super();

        var self = this;
        this.schedulingAction = new SchedulingAction();
        this.schedulingResponseHandler = new SchedulingResponseHandler(this.schedulingAction);

        this.mapper = new RequestMapper();
        this.serverMapper = new ServerResponseMapper();

        this.schedulingTabHandler = new SchedulingTabHandler();
        this.openScheduleTabHandler = new OpenScheduleTabHandler();
        this.mainTemplateTabHandler = new MainTemplateTabHandler();
        this.createTemplateTabHandler = new CreateTemplateTabHandler();

        this.mapper.AddInstance(this.schedulingTabHandler);
        this.mapper.AddInstance(this.openScheduleTabHandler);
        this.mapper.AddInstance(this.mainTemplateTabHandler);
        this.mapper.AddInstance(this.createTemplateTabHandler);

        this.serverMapper.AddInstance(this.schedulingResponseHandler);

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { self.serverMapper.Map(response, self); });
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.mapper.Map(request, self));

        this.InitModels();
    }

    public static createSingleton(): SchedulingStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new SchedulingStore());
    }

    public static createSingletonFrom(store: SchedulingStore, copy: boolean = true): SchedulingStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    private InitModels(): void {
        this.SchedulingTabModel = Immutable.fromJS(SchedulerHelper.getDefaultSchedulingTabModel());
        this.OpenScheduleTabModel = Immutable.fromJS(SchedulerHelper.getDefaultOpenScheduleTabModel());
        this.TemplateTabModel = Immutable.fromJS(SchedulerHelper.getDefaultTemplateTabModel());
        this.CreateTemplateTabModel = Immutable.fromJS(SchedulerHelper.getDefaultCreateTemplateTabModel());
    }
}

export { SchedulingStore, defaultInstance as schedulingStore };
